var map = {
	"./archery.jpg": [
		8914,
		914
	],
	"./basketball.jpg": [
		3943,
		943
	],
	"./boxing.jpg": [
		9271,
		271
	],
	"./boxing.png": [
		9159,
		159
	],
	"./cycling.jpg": [
		4663,
		663
	],
	"./fencing.jpg": [
		6162,
		162
	],
	"./golf.jpg": [
		5134,
		134
	],
	"./judo.jpg": [
		2802,
		802
	],
	"./old/archery.jpg": [
		9264,
		264
	],
	"./old/basketball.jpg": [
		6373,
		373
	],
	"./old/boxing.jpg": [
		8189,
		189
	],
	"./old/cycling.jpg": [
		7561,
		561
	],
	"./old/fencing.jpg": [
		3795,
		176
	],
	"./old/golf.jpg": [
		3656,
		656
	],
	"./old/judo.jpg": [
		2160,
		160
	],
	"./old/sailing.jpg": [
		3955,
		955
	],
	"./old/shooting.jpg": [
		1599,
		599
	],
	"./old/swimming.jpg": [
		8575,
		575
	],
	"./old/taekwondo.jpg": [
		6362,
		362
	],
	"./old/tennis.jpg": [
		5225,
		225
	],
	"./old/track.jpg": [
		6939,
		939
	],
	"./old/triathlon.jpg": [
		6993,
		993
	],
	"./old/volleyball.jpg": [
		1368,
		368
	],
	"./sailing.jpg": [
		125,
		125
	],
	"./shooting.jpg": [
		1341,
		341
	],
	"./swimming.jpg": [
		7521,
		521
	],
	"./taekwondo.jpg": [
		532,
		532
	],
	"./tennis.jpg": [
		815,
		815
	],
	"./track.jpg": [
		629,
		629
	],
	"./triathlon.jpg": [
		7763,
		763
	],
	"./volleyball.jpg": [
		3158,
		158
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8890;
module.exports = webpackAsyncContext;